import API from '@/API/API'

const Navigator = {
  goHome (self) {
    self.$router.push('/')
  },
  goAdmin (self) {
    self.$router.push('/admin')
  },
  goAdminLogin (self) {
    self.$router.push('/admin/login')
  },
  goServices (self) {
    self.$router.push('/admin/services')
  },
  goAdminListings (self) {
    self.$router.push('/admin/listings')
  },
  goListingDetails (self,id) {
    if(!id){
      return
    }
    self.$router.push('/account/listing/details/' + id)
  },
  goUsers (self) {
    self.$router.push('/admin/users')
  },
  goSiteSettings (self) {
    self.$router.push('/admin/site-settings')
  },
  goRegister (self,afterRoute) {
    if(afterRoute) {
      self.$router.push(`/account/register/${afterRoute}`)
    } else {
      self.$router.push('/account/register')
    }
  },
  goLogin (self,afterRoute) {
    if(afterRoute) {
      self.$router.push(`/account/login/${afterRoute}`)
    }else{
      self.$router.push('/account/login')
    }
  },
  logout (self) {
    localStorage.ECDsessionid = null;
    if(self.$route.path != '/') {
      self.$router.push('/')
    }
  },
  addService (self) {
    self.$router.push('/admin/services/add');
  },
  editService (self, serviceId) {
    self.$router.push('/admin/services/edit/' + serviceId);
  },
  serviceFields (self,serviceId){
    self.$router.push('/admin/services/fields/' + serviceId)
  },
  goListings (self){
    self.$router.push('/account/listings');
  },
  goPay (self,id){
    self.$router.push('/account/listing/pay/' + id);
  },
  listingSuccess (self){
    self.$router.push('/account/listing/success/');
  },
  goCreateListing (self){
    self.$router.push('/account/listing/create');
  },
  editListing (self,id){
    self.$router.push('/account/listing/edit/' + id);
  },
  goFeed (self,id){
    self.$router.push('/feed/' + id)
  },
  goFavorites (self){
    self.$router.push('/account/favorites')
  },
  goAdminListings(self){
    self.$router.push('/admin/listings')
  },
  goAdminListing(self,listingId){
    self.$router.push('/admin/listing/' + listingId)
  },
  goMaintenance(self){
    self.$router.push('/maintenance')
  },
  forgotPassword(self){
    self.$router.push('/account/forgotPassword')
  },
  myAccount(self){
    self.$router.push('/account')
  },
  adminCoupons(self){
    self.$router.push('/admin/coupons')
  },
  adminCreateCoupon(self){
    self.$router.push('/admin/coupon/create')
  }
}

export default Navigator



// WEBPACK FOOTER //
// ./src/router/navigator.js